import { IAssembly } from 'src/interfaces';

/**
 * Build PATCH payloads only for assemblies whose tag membership changed vs persisted.
 */
export const buildAssemblyTagAssignmentUpdates = (
  currentSelected: IAssembly[],
  persistedSelected: IAssembly[] | undefined,
  tagId: number,
): IAssembly[] => {
  const persisted = persistedSelected ?? [];
  const initialIds = new Set(persisted.map((a) => a.id));
  const currentIds = new Set(currentSelected.map((a) => a.id));

  const removedIds = [...initialIds].filter((id) => !currentIds.has(id));
  const addedIds = [...currentIds].filter((id) => !initialIds.has(id));

  const updates: IAssembly[] = [];

  for (const id of removedIds) {
    const assembly = persisted.find((a) => a.id === id);
    if (!assembly) continue;
    const nextTags =
      assembly.assembly_tag_id?.filter((tid) => tid !== tagId) ?? [];
    updates.push({ ...assembly, assembly_tag_id: nextTags });
  }

  for (const id of addedIds) {
    const assembly = currentSelected.find((a) => a.id === id);
    if (!assembly) continue;
    const tags = assembly.assembly_tag_id ?? [];
    updates.push({
      ...assembly,
      assembly_tag_id: tags.includes(tagId) ? tags : [...tags, tagId],
    });
  }

  return updates;
};
